import React, { useEffect } from 'react';
import { AppProps } from 'next/app';
import { initializeRio } from '@src/lib/rio';
import { initClient } from '@chegg/rio2-web-client';
import { OptimizelyProvider } from '@optimizely/react-sdk';
import Cookies from 'js-cookie';
import { getOptimizelyClient } from '@src/lib/optimizley';

initializeRio();

const App: React.FC<AppProps> = (props) => {
  const { pageProps, Component } = props;
  const cvid = Cookies.get('CVID') || null;

  useEffect(() => {
    initClient();
  }, []);

  return (
    <OptimizelyProvider optimizely={getOptimizelyClient()} user={{ id: cvid }}>
      <Component {...pageProps} />
    </OptimizelyProvider>
  );
};

export default App;
